<template>
    <div class="news-manage">
      <div class="op-btn-group" style="color: #FA6A43;font-weight: bolder">
        新闻录入过程请注意写明新闻来源，以防侵权；录入的新闻将会选取最新录入的十条显示给用户，随机同时展示三条；若新闻系统中新闻太多时，建议删除较旧的新闻数据
      </div>
      <div class="op-btn-group">
        <el-button size="mini" type="primary" @click="showNewsAddDialog">新闻录入</el-button>
<!--        <el-button size="mini" type="primary" @click="batchDeleteNews">批量删除</el-button>-->
        <span style="margin-left: 10px;color: #409eff">设置新闻刷新时间(秒/次)：</span>
        <el-input-number size="mini" :step="0.5" v-model="newsRefreshInterval" :min="2"></el-input-number>
        <el-button size="mini" type="primary" @click="saveNewsRefreshInterval">确定</el-button>
      </div>
      <el-table
        size="mini"
        :data="newsTableData"
        border
        style="width: 100%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          fixed
          prop="createDate"
          label="创建时间"
          width="auto">
          <template slot-scope="scope">
            <span>{{scope.row.createDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="newsTitle"
          label="新闻标题"
          width="auto">
        </el-table-column>
        <el-table-column
          prop="newsPath"
          label="新闻链接"
          width="auto">
          <template slot-scope="scope">
            <a :href="scope.row.newsPath" target="_blank">{{scope.row.newsPath}}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="newsImagePath"
          label="新闻图片"
          width="auto">
          <template slot-scope="scope">
            <a :href="scope.row.newsImagePath" target="_blank">{{scope.row.newsImagePath}}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="source"
          label="新闻来源"
          width="auto">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="auto">
          <template slot-scope="scope">
            <el-button @click="editNews(scope.row)" type="text" size="small">编辑</el-button>
            <el-button type="text" size="small" @click="deleteNews(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px 0; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </div>

      <div v-if="drawerShow">
        <el-drawer
          title="新闻录入"
          :visible.sync="drawerShow"
          :before-close="handleCloseNewsAdd">
          <div style="padding: 10px">
            <el-form :model="newNews" :rules="newNewsRules" ref="newNewsForm" label-width="120px" size="mini">
              <el-form-item label="新闻标题" prop="newsTitle">
                <el-input v-model="newNews.newsTitle" placeholder="请输入新闻标题"></el-input>
              </el-form-item>
              <el-form-item label="新闻链接" prop="newsPath">
                <el-input v-model="newNews.newsPath" placeholder="请输入新闻链接"></el-input>
              </el-form-item>
              <el-form-item label="新闻图片链接" prop="newsImagePath">
                <el-input v-model="newNews.newsImagePath" placeholder="请输入新闻图片链接"></el-input>
              </el-form-item>
              <el-form-item label="新闻来源" prop="source">
                <el-input v-model="newNews.source" placeholder="请输入新闻来源"></el-input>
              </el-form-item>
            </el-form>
            <span style="color: #FA6A43;margin-left: 120px">注：新闻来源若不填写，可能造成版权纠纷</span>

            <div style="margin-top: 20px">
              <el-button size="mini" type="primary" @click="handleClickSave">保存</el-button>
              <el-button size="mini" type="primary" @click="drawerShow = false">取消</el-button>
            </div>
          </div>
        </el-drawer>
      </div>

    </div>
</template>

<script>
import utilService from '../../utils/utilService'
export default {
  name: 'NewsManage',
  data () {
    let validateSyn = (rule, value, callback) => {
      utilService.checkSensitive({sensitive: value.trim()}, callback)
    }
    return {
      newsTableData: [],
      drawerShow: false,
      newsRefreshInterval: 3,
      newNews: {
        isEdit: false,
        id: '',
        newsTitle: '',
        newsPath: '',
        newsImagePath: '',
        source: ''
      },
      newNewsRules: {
        newsTitle: [{ required: true, message: '请输入新闻标题', trigger: 'blur' }, {validator: validateSyn, trigger: 'blur'}],
        newsPath: [{ required: true, message: '请输入新闻链接', trigger: 'blur' }, {validator: validateSyn, trigger: 'blur'}],
        newsImagePath: [{ required: true, message: '请输入新闻图片链接', trigger: 'blur' }, {validator: validateSyn, trigger: 'blur'}],
        source: {validator: validateSyn, trigger: 'blur'}
      },
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  methods: {
    editNews (row) {
      this.newNews = row
      this.drawerShow = true
    },
    deleteNews (row) {
      this.$confirm('确认删除？')
        .then(_ => {
          this.$http.delete(this.$api.deleteNewsById.url, {
            id: row.id
          }).then(_ => {
            if (_ && _.code === 200) {
              this.$message.success('删除成功！')
              this.initNews()
            }
          })
        })
        .catch(_ => {})
    },
    showNewsAddDialog () {
      this.newNews = {
        isEdit: false,
        id: '',
        newsTitle: '',
        newsPath: '',
        newsImagePath: '',
        source: ''
      }
      this.drawerShow = true
    },
    batchDeleteNews () {

    },
    handleCloseNewsAdd (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleClickSave () {
      this.$refs['newNewsForm'].validate((valid) => {
        if (valid) {
          if (!this.newNews.isEdit) {
            this.$http.post(this.$api.saveNews.url, {
              newsTitle: this.newNews.newsTitle,
              newsPath: this.newNews.newsPath,
              newsImagePath: this.newNews.newsImagePath,
              source: this.newNews.source
            }).then(_ => {
              if (_ && _.code === 200) {
                this.$message.success('添加成功！')
                this.initNews()
              }
            })
            this.drawerShow = false
          } else {
            this.$http.put(this.$api.updateNews.url, {
              id: this.newNews.id,
              newsTitle: this.newNews.newsTitle,
              newsPath: this.newNews.newsPath,
              newsImagePath: this.newNews.newsImagePath,
              source: this.newNews.source
            }).then(_ => {
              if (_ && _.code === 200) {
                this.$message.success('更新成功！')
                this.initNews()
              }
            })
            this.drawerShow = false
          }
        } else {
          return false
        }
      })
    },
    initNews () {
      this.$http.post(this.$api.newsRefreshInterval.url).then(_ => {
        if (_.code === 200 && _.data) {
          this.newsRefreshInterval = _.data
        }
      })
      this.$http.get(this.$api.getNews.url, {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }).then(_ => {
        if (_ && _.code === 200) {
          this.newsTableData = _.data.list || []
          this.page.pageNum = _.data.pageNum
          this.page.pageSize = _.data.pageSize
          this.page.total = _.data.total
        }
      })
    },
    saveNewsRefreshInterval () {
      console.log(this.newsRefreshInterval)
      this.$http.post(`${this.$api.newsRefreshInterval.url}?timeInterVal=${this.newsRefreshInterval}`).then(_ => {
        if (_ && _.code === 200) {
          this.$message.success('修改成功！')
        }
      })
    },
    handleCurrentChange (e) {
      this.page.pageNum = e
      this.initNews()
    },
    handleSizeChange (e) {
      this.page.pageSize = e
      this.initNews()
    }
  },
  created () {
    this.initNews()
  }
}
</script>

<style scoped>
  .news-manage {
    width: 1200px;
    margin: auto;
    text-align: left;
    min-height: calc(100vh - 200px);
  }
  .op-btn-group {
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsManage/NewsManage.vue